function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  transform: "translate(46.905 20.374)",
  strokeWidth: 0.014111
}, /*#__PURE__*/React.createElement("rect", {
  x: -46.905,
  y: -20.374,
  width: 12.7,
  height: 8.4667,
  fill: "#d7141a"
}), /*#__PURE__*/React.createElement("rect", {
  x: -46.905,
  y: -20.374,
  width: 12.7,
  height: 4.2333,
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  d: "m-40.555-16.14-6.35-4.2333v8.4667z",
  fill: "#11457e"
}));

function SvgCzechFlag(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "12.7mm",
    height: "8.4667mm",
    viewBox: "0 0 12.7 8.4667",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCzechFlag);
export default __webpack_public_path__ + "static/media/czech-flag.6bd32e0d.svg";
export { ForwardRef as ReactComponent };